import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApiClient } from '../services/apiClient';

const ProtectedRoute: React.FC = () => {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApiClient();
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  // Routes that should bypass onboarding enforcement
  const bypassOnboarding =
    location.pathname.startsWith('/billing') ||
    location.pathname.startsWith('/admin');

  useEffect(() => {
    if (!isLoaded || !isSignedIn) return;

    if (bypassOnboarding) {
      setChecking(false);
      return;
    }

    api.getOnboardingStatus()
      .then((status) => {
        const needsOnboarding =
          status.onboarding_status === 'not_started' ||
          status.onboarding_status === 'in_progress';
        if (needsOnboarding && !location.pathname.startsWith('/onboarding')) {
          navigate('/onboarding', { replace: true });
        }
        // Any other status — allow access to the protected route.
      })
      .catch(() => {
        navigate('/onboarding', { replace: true });
      })
      .finally(() => setChecking(false));
  }, [isLoaded, isSignedIn, bypassOnboarding]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isLoaded) return null;

  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  if (checking) return null;

  return <Outlet />;
};

export default ProtectedRoute;
